import { render, staticRenderFns } from "./ModalVerDetalleSerTec.vue?vue&type=template&id=31c318a0&"
import script from "./ModalVerDetalleSerTec.vue?vue&type=script&lang=ts&"
export * from "./ModalVerDetalleSerTec.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerDetalleSerTec.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('31c318a0', component.options)
    } else {
      api.reload('31c318a0', component.options)
    }
    module.hot.accept("./ModalVerDetalleSerTec.vue?vue&type=template&id=31c318a0&", function () {
      api.rerender('31c318a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/OrdenesSerTec/ModalVerDetalleSerTec.vue"
export default component.exports